export default __webpack_public_path__ + "static/media/tent_dark.fd0cbb50.png";